module.exports = __webpack_public_path__ + "static/img/zprj.6b1fb842.png";